import script from "./ContactPointPatientList.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactPointPatientList.vue?vue&type=script&setup=true&lang=js"

import "./ContactPointPatientList.vue?vue&type=style&index=0&id=6cc764c8&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6cc764c8"]])

export default __exports__